var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传插件",
            visible: _vm.dialog.visible,
            width: "40%",
            "append-to-body": "",
            "modal-append-to-body": false,
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.closed,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    disabled: _vm.dialog.disabled,
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "插件上传：", prop: "fileUrl" } },
                    [
                      !_vm.form.fileUrl
                        ? _c(
                            "el-upload",
                            {
                              attrs: {
                                "before-upload": _vm.checkUpload,
                                "http-request": _vm.upload,
                                "show-file-list": false,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "primary",
                                    loading: _vm.uploadBtnLoading,
                                  },
                                },
                                [_vm._v("上传插件")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.fileUrl
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.currentUploadFileName)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "插件ID：", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入插件ID",
                          maxlength: "64",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "插件名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入插件名称",
                          maxlength: "32",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { height: "20px", "line-height": "20px" },
                      attrs: { label: " " },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "说明: 如若插件ID与已有插件ID重复，名称将会进行覆盖"
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "更新说明：", prop: "descr" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入插件描述",
                          maxlength: "128",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.descr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "descr", $$v)
                          },
                          expression: "form.descr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "插件版本：", prop: "ver" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入插件版本",
                          maxlength: "16",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.ver,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ver", $$v)
                          },
                          expression: "form.ver",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支持APP版本：", prop: "appVer" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input-number", {
                            staticStyle: {
                              "margin-right": "10px",
                              width: "180px",
                            },
                            attrs: { precision: 0, label: "描述文字" },
                            model: {
                              value: _vm.form.appVer,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appVer", $$v)
                              },
                              expression: "form.appVer",
                            },
                          }),
                          _c("el-input-number", {
                            attrs: { label: "描述文字" },
                            model: {
                              value: _vm.form.appVerMax,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appVerMax", $$v)
                              },
                              expression: "form.appVerMax",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "margin-top": "-10px",
                        "margin-bottom": "0px",
                      },
                      attrs: { label: " " },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "180px",
                              "text-align": "center",
                              display: "inline-block",
                              color: "#a7a7a7",
                              "margin-right": "10px",
                            },
                          },
                          [_vm._v("\n              最小版本\n            ")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "180px",
                              "text-align": "center",
                              display: "inline-block",
                              color: "#a7a7a7",
                            },
                          },
                          [_vm._v("\n              最大版本\n            ")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支持SDK版本：", prop: "sdkVer" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input-number", {
                            staticStyle: {
                              "margin-right": "10px",
                              position: "relative",
                            },
                            attrs: { label: "描述文字" },
                            model: {
                              value: _vm.form.sdkVer,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sdkVer", $$v)
                              },
                              expression: "form.sdkVer",
                            },
                          }),
                          _c("el-input-number", {
                            attrs: { label: "描述文字" },
                            model: {
                              value: _vm.form.sdkVerMax,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sdkVerMax", $$v)
                              },
                              expression: "form.sdkVerMax",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "margin-top": "-10px",
                        "margin-bottom": "0px",
                      },
                      attrs: { label: " " },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "180px",
                              "text-align": "center",
                              display: "inline-block",
                              color: "#a7a7a7",
                              "margin-right": "10px",
                            },
                          },
                          [_vm._v("\n              最小版本\n            ")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "180px",
                              "text-align": "center",
                              display: "inline-block",
                              color: "#a7a7a7",
                            },
                          },
                          [_vm._v("\n              最大版本\n            ")]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: {}, attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }